import { render, staticRenderFns } from "./h5MyOrder.vue?vue&type=template&id=2d520276&scoped=true&"
import script from "./h5MyOrder.vue?vue&type=script&lang=js&"
export * from "./h5MyOrder.vue?vue&type=script&lang=js&"
import style0 from "./h5MyOrder.vue?vue&type=style&index=0&id=2d520276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d520276",
  null
  
)

export default component.exports